module.exports = __webpack_public_path__ + "r-v3/img/ico_camera_transition.0f73fe9e.svg";